<template>
    <div class="customer-profile customer-details-page">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                :params="{ id }"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <div class="wrap-content">
                    <div class="filter-section row-min-space profile-filter">
                        <div class="row">
                            <div
                                class="col-xs-6 col-md-3 filter-title-section font-sm"
                            >
                                <h2>{{ $route.meta.name }}</h2>
                            </div>

                            <!-- Scope buttons -->
                            <div class="col-md-9">
                                <div class="text-right auto-adjust-btn-padding">
                                    <div
                                        class="btn-auto d-inline-block text-right go-back-profile"
                                    >
                                        <router-link
                                            :to="{
                                                name: previousRoute,
                                            }"
                                            class="btn btn-link go-back-btn"
                                        >
                                            <span>
                                                <i class="icon-caret-left"></i>
                                            </span>
                                            <span>Go back</span>
                                        </router-link>
                                    </div>
                                    <!-- <div
                                        :class="[
                                            'btn-auto d-inline-block text-center btn-profile-section',
                                        ]"
                                    >
                                        <base-button
                                            v-show="
                                                !hideCancelButton &&
                                                    hasScopes(
                                                        'kyc-status-review'
                                                    )
                                            "
                                            v-b-modal.cancel-review-process-popup
                                            btn-label="Cancel Review Process"
                                            btn-type="button"
                                            btn-variant="link font-semibold"
                                            :css-class="
                                                isDisabledCancelReviewBtn
                                                    ? 'link-disabled'
                                                    : ''
                                            "
                                        ></base-button>
                                    </div>
                                    <div
                                        class="btn-auto d-inline-block btn-profile-section"
                                    >
                                        <base-button
                                            v-show="
                                                showKycButton &&
                                                    hasScopes(
                                                        'kyc-status-review'
                                                    )
                                            "
                                            v-b-modal.kyc-status-review-popup
                                            :css-class="
                                                isDisabledKycStatusReview
                                                    ? 'button-disabled'
                                                    : ''
                                            "
                                            btn-label="KYC STATUS REVIEW"
                                            btn-type="button"
                                            btn-variant="primary"
                                        ></base-button>
                                    </div>
                                    <div
                                        class="btn-auto d-inline-block btn-profile-section"
                                    >
                                        <base-button
                                            v-show="
                                                showOpenAlertBtn &&
                                                    hasScopes('open-alerts')
                                            "
                                            v-b-modal.manual-alert-popup
                                            btn-label="Create Manual Alert"
                                            btn-type="button"
                                            btn-variant="secondary"
                                        ></base-button>
                                    </div>
                                    <div class="btn-auto d-inline-block">
                                        <button
                                            v-show="
                                                showInitiateButton &&
                                                    (leastRole ||
                                                        leastRoleDone) &&
                                                    hasScopes(
                                                        'kyc-status-review'
                                                    )
                                            "
                                            :class="[
                                                'btn btn-primary',
                                                {
                                                    'button-disabled': isBtnDisabled,
                                                },
                                            ]"
                                            type="button"
                                            @click="selectRecord()"
                                        >
                                            <span class="btn-text">
                                                Initiate Review</span
                                            >
                                            <span class="loader"></span>
                                        </button>
                                    </div>
                                    <div class="btn-auto d-inline-block">
                                        <button
                                            v-show="
                                                showUnlockAlertButton &&
                                                    hasScopes('unlock-alerts')
                                            "
                                            :class="['btn btn-primary']"
                                            type="button"
                                            @click="selectRecord()"
                                        >
                                            <span class="btn-text">
                                                Unlock Review</span
                                            >
                                            <span class="loader"></span>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <!-- Scope buttons -->
                        </div>
                    </div>
                    <router-view></router-view>
                    <base-toast></base-toast>
                    <!-- <initiate-review-popup></initiate-review-popup> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import resource from '@/api/resource'
import request from '@/utils/request'
import initiateReviewPopup from '@/components/popups/InitiateReviewPopup'
export default {
    components: {
        initiateReviewPopup,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            required: true,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    menuLabel: 'Customer Profile',
                    name: 'temp-customer-information',
                    permission: ['view-customer-profile'],
                },
                // {
                //     menuLabel: 'Name Screening',
                //     name: 'screening-customer',
                //     permission: ['view-customer-profile'],
                // },
                // {
                //     menuLabel: 'Document Verification',
                //     name: 'document-verification',
                //     permission: ['view-customer-profile'],
                // },
                // {
                //     menuLabel: 'KYC Risk Rating',
                //     name: 'kyc-risk-rating',
                //     permission: ['view-customer-profile'],
                // },
                // {
                //     menuLabel: 'Activity Timeline',
                //     name: 'activity-timeline',
                //     permission: ['view-customer-profile'],
                // },
            ],
            showOpenAlertBtn: false,
            previousRoute: 'view-alerts',
            showInitiateButton: false,
            hideCancelButton: true,
            showKycButton: false,
            showUnlockAlertButton: false,
            leastRole: false,
            leastRoleDone: false,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'customerRecord',
            'permissions',
            'alertRecord',
            'kycRole',
            'userId',
            'hasScopes',
            'dataSegmentId',
            'canReview',
        ]),
        isBtnDisabled() {
            if (
                this.customerRecord.nameScreeningStatus == 'completed' ||
                this.customerRecord.nameScreeningStatus == 'locked'
            ) {
                return false
            }

            return true
        },
        isDisabledCancelReviewBtn() {
            if (this.leastRole) {
                if (this.alertRecord.canCancelReview) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        isDisabledKycStatusReview() {
            if (this.leastRole && this.alertRecord.nameScreeningStatus) {
                if (this.alertRecord.canReview) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        alertRecord() {
            this.getAlertDetails()
        },
        customerRecord(value) {
            if (value) {
                this.getAlertDetails()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getAlertDetails()
        this.getRiskLevelReviews()
        // this.$store.commit('setRefreshProfile', true)
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getAlertDetails() {
            /*set previous url*/
            this.previousRoute = localStorage.getItem('goBackUrl')

            let customer = this.customerRecord
            if (_.isEmpty(customer)) {
                let resourceApi = new resource('customers')
                let customerDetails = await resourceApi.get(
                    this.$route.params.id
                )
                customer = customerDetails.data.data
            }

            if (this.previousRoute == 'view-customer-profile') {
                if (
                    customer &&
                    (customer.status == 'pending' ||
                        customer.status == 'rejected')
                ) {
                    this.showOpenAlertBtn = false
                } else {
                    this.showOpenAlertBtn = true
                }
                this.showInitiateButton = false
                this.hideCancelButton = true
                this.showKycButton = false
            } else {
                if (_.isEmpty(this.alertRecord)) {
                    let resourceApi = new resource('alerts')
                    let alertId = localStorage.getItem('alertId')
                    let alertDetails = await resourceApi.get(alertId)
                    await this.$store.commit(
                        'setAlertRecord',
                        alertDetails.data.data
                    )
                }
                /*get alert data*/
                let alertRecord = this.alertRecord
                if (alertRecord && customer) {
                    this.showOpenAlertBtn = false
                    this.showUnlockAlertButton = false
                    if (
                        alertRecord.status == 'pending' &&
                        customer.status !== 'pending' &&
                        alertRecord.updatedByRoles &&
                        !alertRecord.updatedByRoles[this.kycRole]
                    ) {
                        this.showInitiateButton = true
                        this.showKycButton = false
                        this.hideCancelButton = true
                    } else if (alertRecord.status == 'locked') {
                        this.showUnlockAlertButton = true
                        if (
                            alertRecord.status == 'locked' &&
                            customer.status == 'pending' &&
                            alertRecord.updatedById !== this.userId
                        ) {
                            this.showKycButton = false
                            this.hideCancelButton = true
                            this.showInitiateButton = false
                        } else {
                            this.showKycButton = true
                            this.hideCancelButton = false
                            this.showInitiateButton = false
                        }
                    } else if (alertRecord.status == 'approved') {
                        this.showKycButton = false
                        this.hideCancelButton = true
                        this.showInitiateButton = false
                    }else if (alertRecord.status == 'submitted') {
                        this.showKycButton = false
                        this.hideCancelButton = true
                        this.showInitiateButton = false
                    }
                     else if (
                        alertRecord.status == 'pending' &&
                        alertRecord.updatedByRoles &&
                        alertRecord.updatedByRoles[this.kycRole]
                    ) {
                        this.showKycButton = false
                        this.hideCancelButton = true
                        this.showInitiateButton = false
                    } else if (
                        alertRecord.status == 'pending' &&
                        customer.status == 'pending' &&
                        !alertRecord.updatedByRoles
                    ) {
                        this.showInitiateButton = true
                        this.showKycButton = false
                        this.hideCancelButton = true
                    } else if (
                        alertRecord.status == 'pending' &&
                        alertRecord.updatedByRoles &&
                        customer.status == 'pending' &&
                        !alertRecord.updatedByRoles[this.kycRole]
                    ) {
                        if (this.hasScopes('unlock-alerts')) {
                            this.showUnlockAlertButton = false
                            this.showInitiateButton = false
                            this.showKycButton = false
                            this.hideCancelButton = true
                        } else {
                            this.showInitiateButton = true
                            this.showKycButton = false
                            this.hideCancelButton = true
                        }
                    }
                }
            }
        },
        selectRecord() {
            this.$bvModal.show('initiate-review-popup')
        },
        async getRiskLevelReviews() {
            let isLeastRole = false
            let leastRole = false
            try {
                let riskRating = 'low'
                let type = 'on_boarding'
                if (this.alertRecord && this.alertRecord.type) {
                    type = this.alertRecord.type
                }
                if (
                    this.customerRecord &&
                    this.customerRecord.kycSummary &&
                    this.customerRecord.kycSummary.riskRating
                ) {
                    riskRating = this.customerRecord.kycSummary.riskRating
                }
                let { data } = await request({
                    url: `configurations/risk-level-permission/`,
                    method: 'get',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        alertType: type,
                        ref: 'permission',
                    },
                })
                if (data.data && data.data.length)
                    var alert = _.find(data.data, {
                        alertType: type,
                        level: riskRating,
                    })

                if (this.kycRole == 'maker') {
                    if (alert.involvement.maker) {
                        leastRole = true
                    }
                }
                if (this.kycRole == 'checker') {
                    if (alert.involvement.maker) {
                        leastRole = false
                    }
                    if (!alert.involvement.maker && alert.involvement.checker) {
                        leastRole = true
                    }
                    if (
                        this.alertRecord.status == 'pending' &&
                        this.alertRecord.updatedByRoles &&
                        this.alertRecord.updatedByRoles.maker
                    ) {
                        this.leastRoleDone = true
                    }
                }
                if (this.kycRole == 'approver') {
                    if (alert.involvement.maker || alert.involvement.checker) {
                        leastRole = false
                    }
                    if (
                        !alert.involvement.maker &&
                        !alert.involvement.checker &&
                        alert.involvement.approver
                    ) {
                        leastRole = true
                    }
                    if (
                        alert.involvement.maker &&
                        !alert.involvement.checker &&
                        this.alertRecord.status == 'pending' &&
                        this.alertRecord.updatedByRoles['maker']
                    ) {
                        this.leastRoleDone = true
                    }
                    if (
                        this.alertRecord.status == 'pending' &&
                        this.alertRecord.updatedByRoles['checker']
                    ) {
                        this.leastRoleDone = true
                    }
                }
                this.leastRole = leastRole
                isLeastRole = this.leastRole

                if (
                    isLeastRole &&
                    alert.involvement[this.kycRole] &&
                    this.alertRecord &&
                    this.alertRecord.status == 'locked'
                ) {
                    if (this.alertRecord.updatedByRoles[this.kycRole]) {
                        isLeastRole = true
                    }
                }
                localStorage.setItem('isLeastRole', isLeastRole)
                localStorage.setItem('isLeastRoleDone', this.leastRoleDone)
            } catch (error) {
                // console.log(error)
            }
        },
    }, // End of Component > methods
} // End of export default
</script>
